import { useState } from "react"
import NavBar from "./NavBar"
import SideBar from "./SideBar"
import { useDispatch, useSelector } from "react-redux"
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import Cookies from "js-cookie"
import { useGlobalContext } from "./Context"
import TimeModal from "./dateModal"
import { logOut } from "../redux/slices/adminSlice"
import { logOutA } from "../redux/slices/superAdminSlice"
import { deleteAllSensors } from "../redux/slices/allSensorSlice"
import { deleteAllCollectors } from "../redux/slices/collectorsSlice"
import { deleteAllComments } from "../redux/slices/commentsSlice"
import { logOutF } from "../redux/slices/farmsSlice"
import { logOutS } from "../redux/slices/singleFarmSlice"
import { deleteSensor } from "../redux/slices/singleSensorSlice"
import { logOutL } from "../redux/slices/listDamSlice"
import { logOutC } from "../redux/slices/singleCattleSlice"
import { deleteAllCol } from "../redux/slices/singleCollectorSlice"
import { deleteWarn } from "../redux/slices/warningSlice"
import { useEffect } from "react"
import { SplitscreenRounded } from "@mui/icons-material"
import { deleteTime } from "../redux/slices/timeSlice"
import { logOutPP } from "../redux/slices/PensStatusSlice"
import { logOutP } from "../redux/slices/pensSlice"
import moment from "moment"


const PanelLayOut=({children})=>{
    const {currentSfarm}=useSelector(state=>state.p.sFarm)
    const {isLoginA}=useSelector(state=>state.p.adminA)
    const {isLogin}=useSelector(state=>state.p.admin)
    const {isAllTimeOpen,closeSearch,showSearch}=useGlobalContext()
    const dispatch=useDispatch()
    const navigate=useNavigate()
    const handleLogout=()=>{
      dispatch(logOutPP())
      dispatch(logOut())
      dispatch(logOutA())
      dispatch(deleteAllSensors())
      dispatch(deleteAllCollectors())
      dispatch(deleteAllComments())
      dispatch(logOutF())
      dispatch(logOutP())
      dispatch(logOutS())
      dispatch(deleteSensor())
      dispatch(logOutL())
      dispatch(logOutF())
      dispatch(logOutC())
      dispatch(deleteAllCol())
      dispatch(deleteWarn())
      dispatch(deleteTime())
      navigate('/')
  }
 
   
    if(!isLoginA||!Cookies.get('AuthToken')||Cookies.get('AuthToken')===undefined){
        handleLogout()
        return <Navigate to={'/'}/>
    }
   else if(isLoginA&&Cookies.get('AuthToken')){
   
        return <>
        {
            <div onClick={closeSearch} className="panellLayout">
            <NavBar />
            <SideBar/>
            <div  className="ChildrenCon">
            <div className="pagesConLayout" >{children}</div>
            </div>
            </div>
        }
        {isAllTimeOpen&&<TimeModal/>}
        </>
    }
   
}
export default PanelLayOut